import { Box, Typography } from "@mui/material";
import NextLink from "next/link";
import SectionHeading from "@/src/components/common/broadsheet/section-heading";
import MetaLine from "@/src/components/common/broadsheet/meta-line";
import RankedArticleList, {
  rankingCaption,
  type RankingMetric,
} from "@/src/components/journal-site/ranked-articles/ranked-article-list";
import RankedArticle from "@/src/_types/Article/ranked-article";
import { microActionSx } from "@/src/components/common/broadsheet/tokens";
import VISUALLY_HIDDEN from "@/src/utils/visually-hidden";

export default function RankedArticlesSection({
  metric,
  title,
  articles,
  action,
  showJournal,
  hideHeading,
}: {
  metric: RankingMetric;
  title: string;
  articles: RankedArticle[];
  action?: { label: string; href: string };
  showJournal?: boolean;
  hideHeading?: boolean;
}) {
  const count = articles.length;

  return (
    <Box component="section">
      {hideHeading ? (
        <Typography component="h2" sx={VISUALLY_HIDDEN}>
          {title}
        </Typography>
      ) : (
        <SectionHeading title={title} component="h2" action={action} />
      )}

      <MetaLine
        sx={{ mt: hideHeading ? 0.125 : -0.25, mb: 0.5 }}
        items={[
          `${count} article${count === 1 ? "" : "s"}`,
          rankingCaption(metric),
          hideHeading && action ? (
            <Box
              key="all"
              component={NextLink}
              href={action.href}
              sx={microActionSx("custom.link")}
            >
              {action.label}
            </Box>
          ) : null,
        ]}
      />

      <RankedArticleList
        metric={metric}
        articles={articles}
        showJournal={showJournal}
      />
    </Box>
  );
}
